
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetTrackedDangerousSelectedIec as ObiRadarTargetTrackedDangerousSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-tracked-dangerous-selected-iec.js';
 
 
 

 
 export const ObiRadarTargetTrackedDangerousSelectedIec = createComponent({
   react: React,
   tagName: 'obi-radar-target-tracked-dangerous-selected-iec',
   elementClass: ObiRadarTargetTrackedDangerousSelectedIecElement,
   events: {
     
   }
  });
 
 